import {useEffect, useState} from 'react'
import {OperacionCapitalMarketsDetalle} from '../types/types'
import {QueryStatus} from 'src/types'
import {HttpCapitalMarkets} from "../api/httpCapitalMarkets";

export const useDetalle = (idOperacion: number) => {
  const [detalle, setDetalle] = useState<OperacionCapitalMarketsDetalle>()
  const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)

  const fetch = () => {
    setStatus(QueryStatus.Loading)

    HttpCapitalMarkets.getDetalle(idOperacion)
      .then(value => {
        setDetalle(value)
        setStatus(QueryStatus.Success)
      })
      .catch(e => {
        setStatus(QueryStatus.Error)
        console.log(e)
      })
  }

  const refetch = () => fetch()

  useEffect(() => {
    fetch()
  }, [idOperacion])

  return {detalle, refetch, status}
}
